import Vue from "vue";
import VueRouter from "vue-router";

import home from "../views/home/home.vue";
import home2 from "../views/home/home2.vue";
import home3 from "../views/home/home3.vue";
import home4 from "../views/home/home4.vue";
import home5 from "../views/home/home5.vue";

import About from "../views/about/About.vue";
import About2 from "../views/about/About2.vue";

import blogGrid2 from "../views/blog/blogGrid2.vue";
import blogGrid3 from "../views/blog/blogGrid3.vue";
import blogLeftSidebar from "../views/blog/blogLeftSidebar.vue";
import blogRightSidebar from "../views/blog/blogRightSidebar.vue";
import blogSingle from "../views/blog/blogSingle.vue";

import productList from "../views/shop/productList.vue";
import productGrid from "../views/shop/productGrid.vue";
import productCheckout from "../views/shop/productCheckout.vue";
import productSingle from "../views/shop/productSingle.vue";
import productCart from "../views/shop/productCart.vue";
import orderComplete from "../views/shop/orderComplete.vue";

import team from "../views/team/team.vue";
import team2 from "../views/team/team2.vue";

import portfolioFullwidth from "../views/portfolio/portfolioFullwidth.vue";
import portfolioMasonry from "../views/portfolio/portfolioMasonry.vue";
import portfolioSingle from "../views/portfolio/portfolioSingle.vue";

import contact from "../views/contact/contact.vue";
import contact2 from "../views/contact/contact2.vue";

import faq from "../views/pages/faq.vue";
import pricing from "../views/pages/pricing.vue";
import commingSoon from "../views/pages/commingSoon.vue";

import caseStudiesSingle from "../views/case-studies/caseStudiesSingle.vue";
import caseStudies from "../views/case-studies/caseStudies.vue";

import shortcodeAccordion from "../views/shortcode/shortcodeAccordion.vue";
import shortcodeBlogPost from "../views/shortcode/shortcodeBlogPost.vue";
import shortcodeCounter from "../views/shortcode/shortcodeCounter.vue";
import shortcodeFeature from "../views/shortcode/shortcodeFeature.vue";
import shortcodeTeam from "../views/shortcode/shortcodeTeam.vue";
import shortcodeTestmonial from "../views/shortcode/shortcodeTestimonial.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "home", component: home },
  { path: "/home2", name: "home2", component: home2 },
  { path: "/home3", name: "home3", component: home3 },
  { path: "/home4", name: "home4", component: home4 },
  { path: "/home5", name: "home5", component: home5 },

  {
    path: "/about",
    name: "About",
    component: About
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/about2",
    name: "About2",
    component: About2
  },
  {
    path: "/blog-grid-2",
    name: "blogGrid2",
    component: blogGrid2
  },
  {
    path: "/blog-grid-3",
    name: "blogGrid3",
    component: blogGrid3
  },
  {
    path: "/blog-left-sidebar",
    name: "blogLeftSidebar",
    component: blogLeftSidebar
  },

  { path: "/blog-right-sidebar", name: "blogRightSidebar", component: blogRightSidebar },
  { path: "/blog-single", name: "blogSingle", component: blogSingle },

  { path: "/product-list", name: "productList", component: productList },
  { path: "/product-single", name: "productSingle", component: productSingle },
  { path: "/product-grid", name: "productGrid", component: productGrid },
  { path: "/product-checkout", name: "productCheckout", component: productCheckout },
  { path: "/product-cart", name: "productCart", component: productCart },
  { path: "/order-complete", name: "orderComplete", component: orderComplete },

  { path: "/team", name: "team", component: team },
  { path: "/team2", name: "team2", component: team2 },

  { path: "/portfolio-fullwidth", name: "portfolioFullwidth", component: portfolioFullwidth },
  { path: "/portfoli-masonry", name: "portfolioMasonry", component: portfolioMasonry },
  { path: "/portfolio-single", name: "portfolioSingle", component: portfolioSingle },

  { path: "/contact", name: "contact", component: contact },
  { path: "/contact2", name: "contact2", component: contact2 },

  { path: "/faq", name: "faq", component: faq },
  { path: "/pricing", name: "pricing", component: pricing },
  { path: "/comming-soon", name: "commingSoon", component: commingSoon },

  { path: "/case-studies-single", name: "caseStudiesSingle", component: caseStudiesSingle },
  { path: "/case-studies", name: "caseStudies", component: caseStudies },

  { path: "/shortcode-accordion", name: "shortcodeAccordion", component: shortcodeAccordion },
  { path: "/shortcode-blog-post", name: "shortcodeBlogPost", component: shortcodeBlogPost },
  { path: "/shortcode-counter", name: "shortcodeCounter", component: shortcodeCounter },
  { path: "/shortcode-feature", name: "shortcodeFeature", component: shortcodeFeature },
  { path: "/shortcode-team", name: "shortcodeTeam", component: shortcodeTeam },
  { path: "/shortcode-testmonials", name: "shortcodeTestmonial", component: shortcodeTestmonial },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
